/**
 * Contract API Service
 *
 * All contract endpoints are contract-id-based.
 * Step data is stored per step number (3, 5, 6, 7, 8, 9).
 * Contact info (step 10) is global and not per-contract.
 */

import axiosInstance from '../../../../utils/axiosInstance';

// =============================================
// CURRENT USER'S CONTRACT
// =============================================

export const getMyContract = async () => {
  const { data } = await axiosInstance.get('/contracts/me/');
  return data;
};

export const getMyContracts = async () => {
  const { data } = await axiosInstance.get('/contracts/me/');
  return data;
};

// =============================================
// CONTRACT OVERVIEW
// =============================================

export const getContract = async (contractId) => {
  const { data } = await axiosInstance.get(`/contracts/${contractId}/`);
  return data;
};

// =============================================
// STEP DATA (Per Contract)
// =============================================

export const getStepData = async (contractId, step) => {
  const { data } = await axiosInstance.get(`/contracts/${contractId}/steps/${step}/`);
  return data;
};

export const saveStepData = async (contractId, step, stepData) => {
  const { data } = await axiosInstance.put(`/contracts/${contractId}/steps/${step}/`, stepData);
  return data;
};

// =============================================
// CONTACT INFO (Global — Not Per Contract)
// =============================================

export const getContactInfo = async () => {
  const { data } = await axiosInstance.get('/contracts/contact-info/');
  return data;
};

export const saveContactInfo = async (contactData) => {
  const { data } = await axiosInstance.put('/contracts/contact-info/', contactData);
  return data;
};

// Admin-scoped contact info — reads/writes the vendor's contact info by contractId
export const getContactInfoForContract = async (contractId) => {
  const { data } = await axiosInstance.get(`/contracts/${contractId}/contact-info/`);
  return data;
};

export const saveContactInfoForContract = async (contractId, contactData) => {
  const { data } = await axiosInstance.put(`/contracts/${contractId}/contact-info/`, contactData);
  return data;
};

// =============================================
// CONTRACT SUBMISSION
// =============================================

export const submitContract = async (contractId) => {
  const { data } = await axiosInstance.post(`/contracts/${contractId}/submit/`);
  return data;
};

// =============================================
// THANK YOU PAGE CONTENT (Global)
// =============================================

export const getThankYouContent = async () => {
  const { data } = await axiosInstance.get('/thank-you/');
  return data;
};

// =============================================
// DOCUMENT MANAGEMENT
// =============================================

export const generateContractPDF = async (contractId) => {
  const { data } = await axiosInstance.get(`/contracts/${contractId}/pdf/`, {
    responseType: 'blob',
  });
  return data;
};
